var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import InputWithOptions from '../InputWithOptions';
import isUndefined from 'lodash/isUndefined';
import { google2address, includes } from './google2address';

var GoogleAddressInput = function (_React$Component) {
  _inherits(GoogleAddressInput, _React$Component);

  function GoogleAddressInput(params) {
    _classCallCheck(this, GoogleAddressInput);

    var _this = _possibleConstructorReturn(this, (GoogleAddressInput.__proto__ || Object.getPrototypeOf(GoogleAddressInput)).call(this, params));

    _this.state = {
      suggestions: [],
      value: params.value || ''
    };

    _this.autoCompleteRequestId = 0;
    _this.geocodeRequestId = 0;

    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onSet = _this.onSet.bind(_this);
    _this.onManuallyInput = _this.onManuallyInput.bind(_this);
    return _this;
  }

  _createClass(GoogleAddressInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.value !== this.props.value) {
        this._getSuggestions(nextProps.value).then(function (suggestions) {
          _this2.setState({ suggestions: suggestions });
        }).catch(function () {
          // Nothing really to do...
          _this2.setState({ suggestions: [] });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          suggestions = _state.suggestions,
          value = _state.value;


      var options = suggestions.reduce(function (result, value) {
        result.push({ id: result.length, value: value.description });
        return result;
      }, []);

      if (this.props.footer) {
        options = options.concat(_extends({
          id: options.length,
          value: this.props.footer
        }, this.props.footerOptions));
      }

      return React.createElement(
        'div',
        null,
        React.createElement(InputWithOptions, _extends({
          ref: function ref(autocomplete) {
            return _this3.autocomplete = autocomplete;
          }
        }, this.props, {
          onInput: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          onSelect: function onSelect(option) {
            return _this3.onSet(option.value);
          },
          onManuallyInput: this.onManuallyInput,
          value: value,
          options: options
        }))
      );
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.autocomplete.focus();
    }
  }, {
    key: 'select',
    value: function select() {
      this.autocomplete.select();
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var _this4 = this;

      var value = e.target.value;
      this.props.onChange && this.props.onChange(e);
      this.props.onSet && this.props.onSet(null);

      if (!isUndefined(this.props.value)) {
        // Controlled mode
        return;
      }

      this._getSuggestions(value).then(function (suggestions) {
        _this4.setState({ suggestions: suggestions });
      }).catch(function () {
        // Nothing really to do...
        _this4.setState({ suggestions: [] });
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var _this5 = this;

      this.props.onBlur && this.props.onBlur();

      if (this.props.clearSuggestionsOnBlur) {
        this.timer = setTimeout(function () {
          _this5.setState({ suggestions: [] });
        }, 250);
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.props.onFocus && this.props.onFocus();
    }
  }, {
    key: 'onSet',
    value: function onSet(value) {
      var _this6 = this;

      var _props = this.props,
          Client = _props.Client,
          countryCode = _props.countryCode;


      var suggestion = this.state.suggestions.find(function (s) {
        return s.description === value;
      });

      this.setState({ suggestions: [], value: this.props.value || value });

      var request = _defineProperty({
        region: countryCode
      }, suggestion ? 'placeId' : 'address', suggestion ? suggestion.place_id : value);

      var requestId = ++this.geocodeRequestId;
      new Client().geocode({ request: request }).then(function (results) {

        if (requestId !== _this6.geocodeRequestId) {
          return;
        }

        if (results.length === 0) {
          console.error('[GoogleAddressInput] Geocode returned no results on', value);
          _this6.props.onSet && _this6.props.onSet(null);
          // This shouldn't happen since we're running geocode on exactly the same
          // value returned by suggestions list
          return;
        }

        var result = {
          originValue: value,
          googleResult: results[0],
          address: google2address(results[0])
        };

        _this6.props.onSet && _this6.props.onSet(result);
      }).catch(function (e) {
        console.error('[GoogleAddressInput] Geocode failed on', value, e.message);
        _this6.props.onSet && _this6.props.onSet(null);
      });
    }
  }, {
    key: 'onManuallyInput',
    value: function onManuallyInput(value) {
      var _this7 = this;

      this._getSuggestions(value, !isUndefined(this.props.value)).then(function (suggestions) {

        if (suggestions.length === 0) {
          // No suggestion to the text entered
          _this7.props.onSet && _this7.props.onSet(null);
          return;
        }

        _this7.onSet(suggestions[0].description);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: '_getSuggestions',
    value: function _getSuggestions(value, skipSetState) {
      var _this8 = this;

      var _props2 = this.props,
          _props2$valuePrefix = _props2.valuePrefix,
          valuePrefix = _props2$valuePrefix === undefined ? '' : _props2$valuePrefix,
          countryCode = _props2.countryCode,
          types = _props2.types,
          filterTypes = _props2.filterTypes,
          Client = _props2.Client;


      var requestId = ++this.autoCompleteRequestId;

      return new Promise(function (resolve) {

        if (skipSetState) {
          // Controlled mode
          resolve();
          return;
        }

        _this8.setState({ value: value }, function () {
          return resolve();
        });
      }).then(function () {
        if (value === '') {
          return Promise.resolve([]);
        }

        var request = { types: types, components: 'country:' + countryCode, input: valuePrefix + value };

        return new Client().autocomplete({ request: request });
      }).then(function (results) {
        if (results.length === 0) {
          return Promise.resolve([]);
        }

        if (requestId !== _this8.autoCompleteRequestId) {
          return Promise.resolve([]);
        }

        if (filterTypes) {
          results = results.filter(function (result) {
            return includes(result.types, filterTypes);
          });
        }

        return Promise.resolve(results);
      });
    }
  }]);

  return GoogleAddressInput;
}(React.Component);

GoogleAddressInput.defaultProps = {
  magnifyingGlass: true,
  theme: Input.defaultProps.theme,
  autoSelect: true,
  footerOptions: {},
  clearSuggestionsOnBlur: true
};

GoogleAddressInput.propTypes = {
  placeholder: PropTypes.string,
  valuePrefix: PropTypes.string,
  countryCode: PropTypes.string,
  value: PropTypes.string,
  types: PropTypes.array,
  filterTypes: PropTypes.array,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSet: PropTypes.func,
  Client: PropTypes.func.isRequired,
  magnifyingGlass: PropTypes.bool,
  theme: Input.propTypes.theme,
  readOnly: PropTypes.bool,
  autoSelect: PropTypes.bool,
  footer: PropTypes.any,
  footerOptions: PropTypes.object,
  clearSuggestionsOnBlur: PropTypes.bool
};

export default GoogleAddressInput;
//# sourceMappingURL=GoogleAddressInput.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/GoogleAddressInput/GoogleAddressInput.js